import React from "react";
import Button from "react-bootstrap/Button";

const IconButton = ({ children, iconBefore, iconAfter, ...props }) => {
  return (
    <Button {...props}>
      {iconBefore && <i className={`icon-${iconBefore}`}></i>}
      {children}
      {iconAfter && <i className={`icon-${iconAfter}`}></i>}
    </Button>
  );
};

export default IconButton;
